import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import DatePicker from "react-datepicker";
import moment from "moment";
import axios from "axios";

import Button from '../../components/UI/Button/Button';
import Tooltip from '../../components/UI/Tooltip/Tootip';

import HotelTravellers from "../../components/Travellers/HotelTravellers/HotelTravellers";
import AutoSuggestBox from '../../components/UI/AutoSuggestBox/AutoSuggestBox';

import HeadingBox from '../../components/UI/Headings/HeadingBox/HeadingBox';
import HeadingH2 from '../../components/UI/Headings/HeadingH2/HeadingH2';
import HeadingH3 from '../../components/UI/Headings/HeadingH3/HeadingH3';

import BookingEngineInputContainer from '../../components/BookingEngine/BookingEngineInputContainer/BookingEngineInputContainer';
import InputMaterial from '../../components/UI/InputMaterial/InputMaterial';
import BookingEngineContainer from '../../components/BookingEngine/BookingEngineContainer/BookingEngineContainer';
import DividerIcon from '../../components/BookingEngine/DividerIcon/DividerIcon';

import { setHotelCheckinDate, setHotelCheckoutDate, setHotelDestinationCity, setHotelDestinationValidation, searchHotelDestinationCity } from '../../store/actions/index';

import Media from 'react-media';

import classes from './HotelBookingEngine.scss';

class HotelBookingEngine extends Component {

    state = {
        hotelsData: "",
        selectedIndex: 0,
        selectedHotelsIndex: 0,
        selectedLocationsIndex: 0
    }

    // Date Functions Start

    handleChange = date => {
        let startDate = date;
        this.props.onSetCheckinDate(startDate);
    };

    handleChange = ({ startDate, endDate }) => {
        startDate = startDate || this.props.startDate;
        endDate = endDate || this.props.endDate;

        if (startDate.isAfter(endDate)) {
            endDate = startDate;
        }
        this.props.onSetCheckoutDate(startDate, endDate);
    };

    handleChangeStart = startDate => this.handleChange({ startDate });
    handleChangeEnd = endDate => this.handleChange({ endDate });

    // Date Functions End

    getHotels = (value) => {
        axios
        .get(`https://cdn.travelguru.com/api/v2/autosuggest?key=${value}&filter=all&count=10`)
        .then(response => {
          if (response.data.cities.length === 0) {
            this.setState({ hotelsData: '' })
          } else {
            let updatedArray = null;
            const citiesArray = response.data.cities;
            const locationsArray = response.data.locations;
            const hotelsArray = response.data.hotels;
            updatedArray = [...citiesArray, ...locationsArray, ...hotelsArray];
            this.setState({
                hotelsData: updatedArray
            }, () => {
                console.log(this.state.hotelsData);
            })
          }
        })
        .catch(error => {
          console.log(error);
        });
    }

    searchHotelHandler = (event) => {
        if (event.target.value || event.target.value.length >= 0) {
            this.getHotels(event.target.value);
            this.props.onSearchDestinationCity(event.target.value);
        }
    }

    searchHotelsHandler = () => {
        const queryParams = [];
        let totalAdult = 0;
        let totalChildren = 0;

        queryParams.push("city=" + this.props.destinationCity);
        queryParams.push("checkInDate=" + this.props.startDate.format("DD/MM/YYYY"));
        queryParams.push("checkOutDate=" + this.props.endDate.format("DD/MM/YYYY"));
        for(let i = 0; i < this.props.rooms.length; i++) {
            queryParams.push(`rooms${i}noOfAdults=` + this.props.rooms[i].noOfAdults);
            queryParams.push(`rooms${i}noOfChildren=` + this.props.rooms[i].noOfChildren);
            queryParams.push(`rooms${i}id=` + this.props.rooms[i].id);
            queryParams.push(`rooms${i}childArrLength=` + this.props.rooms[i].childrenAge.length);
            for(let j = 0; j < this.props.rooms[i].childrenAge.length; j++) {
                queryParams.push(`rooms${i}childrenAge${j}=` + this.props.rooms[i].childrenAge[j]);
            }
        }
        queryParams.push("rooms=" + this.props.rooms.length);
        queryParams.push("type=all");
        queryParams.push("exclude=rates.hotels.tgRating");

        for (let i = 0; i < this.props.rooms.length; i++) {
            totalAdult += this.props.rooms[i].noOfAdults;
            totalChildren += this.props.rooms[i].noOfChildren;
        }
        queryParams.push('totalAdults=' + totalAdult);
        queryParams.push('totalChildren=' + totalChildren);

        const queryString = queryParams.join("&");
        this.props.history.push({
            pathname: "/hotels/search",
            search: "?" + queryString,
        });
    }

    hoverInHandler = index => {
        this.setState({ selectedIndex: index });
    };

    hoverOutHandler = index => {
        this.setState({ selectedIndex: index });
    };

    autoSuggestKeyHandler = event => {
        event.preventDefault();
        if (event.keyCode === 38) {
        if (this.state.hotelsData) {
            if (this.state.selectedIndex > 0) {
            this.setState(prevState => {
                return { selectedIndex: prevState.selectedIndex - 1 };
            });
            }
            if (this.state.selectedIndex === 0) {
            this.setState(prevState => {
                return { selectedIndex: prevState.hotelsData.length - 1 };
            });
            }
        }
        } else if (event.keyCode === 40) {
        if (this.state.hotelsData) {
            if ( this.state.selectedIndex >= this.state.hotelsData.length - 1 ) {
                this.setState({
                    selectedIndex: 0
                })
            }
            if ( this.state.selectedIndex < this.state.hotelsData.length - 1 ) {
            this.setState( (prevState) => {
                return { selectedIndex: prevState.selectedIndex + 1 };
                });
            }
        }
        } else if (event.keyCode === 13 || event.keyCode === 9) {
            if (this.state.hotelsData) {
                const selectedCity = this.state.hotelsData[this.state.selectedIndex];
                const cityCode = selectedCity.stateCode;
                const countryCode = selectedCity.countryCode;
                const city = selectedCity.displayName;
                this.props.onSetDestinationCity(city, cityCode, countryCode);
            }
        }
    }

    onFocusOutHandler = () => {
        if (this.state.hotelsData) {
            const selectedCity = this.state.hotelsData[this.state.selectedIndex];
            const cityCode = selectedCity.stateCode;
            const countryCode = selectedCity.countryCode;
            const city = selectedCity.displayName;
            this.props.onSetDestinationCity(city, cityCode, countryCode);
        }
    }

    render() {
        const border = '1px solid var(--color-border)';
        return (
            <React.Fragment>
                <BookingEngineContainer>
                    <div>
                        <div style={{ display: this.props.mobileBookingEngine ? 'none' : 'block' }} className={`mb-3`}>
                            <HeadingBox>
                                <div className="mb-1">
                                    <HeadingH2 size={26} weight="Regular" color="Dark">Let's, Book a Hotel!</HeadingH2>
                                </div>
                                <HeadingH3 size={13} weight="Regular" color="Light">Find best hotels around the world</HeadingH3>
                            </HeadingBox>
                        </div>
                        <React.Fragment>
                            <Tooltip showTooltip={false} type="validationDestination" aria-label="Add Destination" />
                            <BookingEngineInputContainer>
                                <InputMaterial
                                    type='text'
                                    label='Enter Destination / Hotel Name'
                                    alignment='left'
                                    style={{borderBottom: !this.props.destinationValid ? '2px solid #ff7d7d': `${border}`}}
                                    value={this.props.destination}
                                    onChange={event => this.searchHotelHandler(event)}
                                    onKeyUp={this.autoSuggestKeyHandler}
                                    onFocus={event => this.searchHotelHandler(event)}
                                    onBlur={this.onFocusOutHandler}
                                />
                            </BookingEngineInputContainer>
                            <AutoSuggestBox
                                toggleAutoSuggest={this.props.autoSuggestBox}
                                hotelsData={this.state.hotelsData}
                                selectCity={this.onFocusOutHandler}
                                hotelsSelectCity={this.onHotelsFocusOutHandler}
                                locationsSelectCity={this.onLocationsFocusOutHandler}
                                activeItem={this.state.selectedIndex}
                                hotelsActiveItem={this.state.selectedHotelsIndex}
                                locationsActiveItem={this.state.selectedLocationsIndex}
                                hoverInHandler={this.hoverInHandler}
                                hoverOutHandler={this.hoverOutHandler}
                            />
                            <div
                                className={`u-relative`}
                                style={{ display: this.props.middleContainer ? "block" : "none" }}>
                                <div className={'u-relative u-flex f-row'}>
                                    <DividerIcon/>
                                    <BookingEngineInputContainer>
                                        <DatePicker
                                        minDate={moment()}
                                        dateFormat="MMM DD, ddd"
                                        selected={this.props.startDate}
                                        selectsStart
                                        startDate={this.props.startDate}
                                        endDate={this.props.endDate}
                                        onChange={this.handleChangeStart}
                                        customInput={ <InputMaterial
                                            type='text'
                                            fieldtype="datepicker"
                                            label='Checkin Date'
                                            alignment='left'
                                            />
                                        }
                                        />
                                    </BookingEngineInputContainer>
                                    <BookingEngineInputContainer>
                                            <DatePicker
                                            minDate={moment()}
                                            dateFormat="MMM DD, ddd"
                                            selected={this.props.endDate}
                                            selectsEnd
                                            startDate={this.props.startDate}
                                            endDate={this.props.endDate}
                                            onChange={this.handleChangeEnd}
                                            ref={(datepicker) => { this.datepicker = datepicker }}
                                            customInput={ <InputMaterial
                                                type='text'
                                                fieldtype="datepicker"
                                                label='Checkout Date'
                                                alignment='right'
                                                />
                                            }
                                            />
                                    </BookingEngineInputContainer>
                                </div>
                            </div>
                        </React.Fragment>
                        <div
                            className={`u-relative ${this.props.location.pathname.trim('').includes('/hotels/search') && window.innerWidth > 600 && window.innerWidth < 900 ? classes.BoxTwo : ''}`}
                            style={{ display: this.props.middleContainer ? "block" : "none" }}>
                            <HotelTravellers />
                        </div>
                    </div>
                    <div style={{
                            marginBottom: (this.props.mobileBookingEngine && window.innerWidth <= 600) ? '0' : 'null',
                            marginTop: this.props.mobileBookingEngine ? '1.5rem': '0',
                            display: this.props.middleContainer ? "block" : "none"
                        }} className={`${classes.ButtonWrapper} u-textAlignCenter`}>
                        <Media query="(max-width: 599px)">
                            {matches =>
                                matches ? <Button theme='Primary' width='Block' type='Search' onClick={this.searchHotelsHandler}>Search</Button> : null}
                        </Media>
                        <Media query="(min-width: 600px) and (max-width: 900px)">
                                {matches =>
                                matches  && !(this.props.location.pathname.trim('').includes('/hotels/search')) ? <Button theme='OutlinePrimary' width='Block' type='Search' onClick={this.searchHotelsHandler}>Search</Button> : null}
                        </Media>
                        <Media query="(min-width: 1200px)">
                                {matches =>
                                matches ? <Button theme='Primary' width='Block' type='Search' onClick={this.searchHotelsHandler}>Search</Button> : null}
                        </Media>
                    </div>
                </BookingEngineContainer>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        mobileBookingEngine: state.ui.mobileBookingEngine,
        destination: state.hotelBookingEngine.destination,
        destinationCity: state.hotelBookingEngine.destinationCity,
        destinationCountry: state.hotelBookingEngine.destinationCountry,
        destinationValid: state.hotelBookingEngine.destinationValid,
        destinationTooltip: state.hotelBookingEngine.destinationTooltip,
        middleContainer: state.hotelBookingEngine.middleContainer,
        autoSuggestBox: state.hotelBookingEngine.autoSuggestBox,
        startDate: state.hotelBookingEngine.checkinDate,
        endDate: state.hotelBookingEngine.checkoutDate,
        rooms: state.hotelTravellers.rooms,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSetCheckinDate: (checkinDate) => dispatch(setHotelCheckinDate(checkinDate)),
        onSetCheckoutDate: (checkinDate, checkoutDate) => dispatch(setHotelCheckoutDate(checkinDate, checkoutDate)),
        onSetDestinationCity: (city, cityCode, countryCode) => dispatch(setHotelDestinationCity(city, cityCode, countryCode)),
        onSearchDestinationCity: (city) => dispatch(searchHotelDestinationCity(city)),
        onSetDestinationValidation: () => dispatch(setHotelDestinationValidation()),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HotelBookingEngine));



// WEBPACK FOOTER //
// ./src/containers/HotelBookingEngine/HotelBookingEngine.js